import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  delay, reduce, indexOf, map, groupBy,
  find, concat, reject as lodashReject,
} from 'lodash';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Autosuggest from 'react-autosuggest';
import {
  FormGroup, ControlLabel,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';
import Avatar from '../avatar';
import styles from './styles.css';


function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function blurAll(parent = document.body) {
  const tmp = document.createElement('input');
  tmp.className = styles.hiddenInput;
  parent.appendChild(tmp);
  delay(() => {
    tmp.focus();
    parent.removeChild(tmp);
  }, 1);
}
const FadeAnimation = ({ children, ...props }) => (
  <CSSTransition
    {...props}
  >
    {children}
  </CSSTransition>
);
FadeAnimation.propTypes = {
  children: PropTypes.element,
};
FadeAnimation.defaultProps = {
  children: null,
};


class UserSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      values: props.users || [],
      loading: false,
      focus: false,
      suggestions: [],
      success: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.getSectionSuggestions = this.getSectionSuggestions.bind(this);
    this.removeTag = this.removeTag.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.renderSectionTitle = this.renderSectionTitle.bind(this);
  }
  
  onChange(event, { newValue }) {
    this.setState({
      value: newValue,
    });
  }

  onFocus() {
    this.setState({ focus: true });
  }

  onBlur() {
    this.setState({ focus: false });
  }

  // Autosuggest will call this function every time
  // you need to update suggestions.
  onSuggestionsFetchRequested({ value }) {
    if (value && value.length > 0) {
      const escapedValue = escapeRegexCharacters(value.trim());
      // const regex = new RegExp(`${escapedValue}`, 'i');
      this.setState({ loading: true, suggestions: [] });
      const { values } = this.state;
      const existentIds = map(values, '_id');
      
      const p = new Promise((resolve, reject) => {
        this.props.dispatch(this.props.fetchUsers(escapedValue))
          .then(
            ({ users }) => {
              const validUsers = reduce(users, (items, user) => {
                if (indexOf(existentIds, user._id) < 0) {
                  items.push(user);
                }
                return items;
              }, []);
              const results = reduce(groupBy(validUsers, 'organization__id'), (items, suggestions, title) => {
                items.push({ title, suggestions });
                return items;
              }, []);
              resolve(results);
            },
            (errors) => {
              reject(errors);
            },
          );
      });
      p.then(
        (suggestions) => {
          this.setState({ suggestions, loading: false });
        },
        () => {
          this.setState({ suggestions: [], loading: false });
        },
      );
      return p;
    }
    return Promise.resolve([]);
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] });
  }

  onSuggestionSelected(event, { suggestion }) {
    if (!suggestion.isEmpty && !suggestion.isHeader) {
      const { values } = this.state;
      const exist = find(values, { _id: suggestion._id });
      if (!exist) {
        const newValues = concat(values, suggestion);
        this.setState({ values: newValues });
        this.props.onSelect(newValues);
      }
    }
    this.setState({ value: '' });
    blurAll(this.element);
  }

  getSuggestionValue(suggestion) {
    if (suggestion.isHeader || suggestion.isEmpty) {
      return '';
    }
    return suggestion.label;
  }

  getSectionSuggestions(section) {
    return section.suggestions;
  }

  removeTag(suggestion) {
    const { values } = this.state;
    const newValues = lodashReject(values, val => val._id === suggestion._id);
    this.setState({ values: newValues });
    this.props.onSelect(newValues);
  }

  renderSuggestion(suggestion, { query }) {
    const label = suggestion.display_name || suggestion.nick_name || suggestion.username;
    const matches = match(label, query);
    const parts = parse(label, matches).map((part, id) => ({ ...part, id }));
    return (
      <a href="" onClick={(e) => { e.preventDefault(); }}>
        <Avatar small user={suggestion} />
        <span>
          {parts.map((part) => {
            const className = part.highlight ? styles.tagHighlight : null;
            return (
              <span className={className} key={part.id}>
                {part.text}
              </span>
            );
          })}
        </span>
      </a>
    );
  }

  renderSectionTitle() {
    return null;
  }

  render() {
    const {
      value, suggestions, focus,
      loading, values,
    } = this.state;

    const { disabled, label } = this.props;


    const inputProps = {
      placeholder: 'type a user name...',
      value,
      className: styles.tagInput,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      disabled,
    };
    const theme = {
      container: styles.autocomplete,
      suggestionsContainer: `dropdown open ${styles.suggestionsContainer}`,
      sectionContainer: `dropdown-menu ${styles.sectionContainer}`,
      suggestionsList: `dropdown-menu ${styles.suggestionsList}`,
      sectionTitle: 'dropdown-header',
      suggestion: '',
      suggestionFocused: 'active',
    };


    const cls = [styles.tagInputField];
    if (focus) {
      cls.push(styles.tagInputFieldFocus);
    }
    if (loading) {
      cls.push(styles.tagInputFieldLoading);
    }

    return (
      <div>
        <FormGroup>
          <ControlLabel>{label}:</ControlLabel>
          <div
            ref={(el) => { this.element = el; }}
            className={`${cls.join(' ')}`}
          >
            <TransitionGroup className={styles.tagList}>
              {values.map((tag) => {
                const tCls = [styles.tag];
                tCls.push(styles.valueTag);
                tCls.push(styles.userTag);
                if (disabled) {
                  tCls.push(styles.disabledTag);
                }
                const lbl = tag.display_name || tag.nick_name || tag.username;
                return (
                  <FadeAnimation
                    classNames="tag"
                    timeout={500}
                    key={tag._id}
                  >
                    <span className={`${tCls.join(' ')}`}>
                      <Avatar small user={tag} />
                      <span className={styles.tagLabel}>{lbl}</span>
                      <a
                        href=""
                        className={styles.tagTrash}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (!disabled) {
                            this.removeTag(tag);
                          }
                        }}
                      >
                        <Fa name="times" />
                      </a>
                    </span>
                  </FadeAnimation>
                );
              })}
              <FadeAnimation
                classNames="tag"
                timeout={500}
              >
                <div className={styles.autocompleteWrapper}>
                  <Autosuggest
                    theme={theme}
                    suggestions={suggestions}
                    multiSection
                    renderSectionTitle={this.renderSectionTitle}
                    getSectionSuggestions={this.getSectionSuggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    shouldRenderSuggestions={() => true}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps}
                  />
                  <Fa name="spinner" spin className={styles.spinner} />
                </div>
              </FadeAnimation>
            </TransitionGroup>
          </div>
        </FormGroup>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

UserSelector.propTypes = {
  dispatch: PropTypes.func.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onSelect: PropTypes.func,
  users: PropTypes.arrayOf(PropTypes.shape({})),
};

UserSelector.defaultProps = {
  disabled: false,
  label: 'Select User',
  onSelect: () => {},
  users: [],
};


export default connect(mapStateToProps)(UserSelector);
